import { Observable, timer } from 'rxjs';

import { NetworkEffects, setOffline, setOnline } from './network-status.state';

import { environment } from '../../../environments/environment';
import { rootStore } from '../extension-store/extension.store';
import UtilsService from '../utils/utils.service';

const networkStatusTrigger$: Observable<number> = timer(
  0,
  environment.defaultTimings.networkStatusCheckIntervalInSeconds * 1000
);

const checkNetworkStatus = async () => {
  if (!globalThis.navigator.onLine) {
    rootStore.dispatch(setOffline());
    return;
  }

  // If online check a real URL to verify the network status
  try {
    await fetch('https://www.google.com'); // TODO: Replace with a more reliable URL
    rootStore.dispatch(setOnline());
  } catch (error) {
    rootStore.dispatch(setOffline());
  }
};

const NetworkStatusService = {
  init: async () => {
    UtilsService.debugLog('Network Status Service Init');
    await rootStore.dispatch(NetworkEffects.getPrivateIp());
    networkStatusTrigger$.subscribe(async () => {
      await checkNetworkStatus();
    });
  },
};

export default NetworkStatusService;
